<div class="avatar-badge" style="width: fit-content">
  <nz-avatar
    [nzSize]="24"
    [nzSrc]="getSafeImageUrl(entity[urlProperty])"
    [nzAlt]="entity.id"
  ></nz-avatar>
  <span class="text-label-12 text-dark text-semibold text-nowrap">
    @if (isCurrency) {
      {{entity.name}} ({{entity.isoCode}})
    } @else {
      @for (labelProperty of labelProperties; track labelProperty) {
        {{entity[labelProperty] ? (entity[labelProperty] + ' ') : ''}}
      }
    }
  </span>
</div>
